<template>
  <SelectorPanel type="content" :force-full-screen="true">
    <EosIframe
      v-if="isActive"
      :route="eosRoute"
      height="100vh"
      :key="eosRoute"
    />
  </SelectorPanel>
</template>

<script>
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";

const EOS_PREFIX = "/seerist";
const SEERIST_PREFIX = `/${DETAIL_SIDEBAR_TYPES.content}`;

export default {
  name: "EosContentSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel.vue"),
    EosIframe: () => import("@/components/eos/EosIframe"),
  },
  data() {
    return {
      path: this.$route.path,
    };
  },
  computed: {
    isActive() {
      return this.path.startsWith(SEERIST_PREFIX);
    },
    eosRoute() {
      return this.path.replace(SEERIST_PREFIX, EOS_PREFIX);
    },
  },
  watch: {
    "$route.path"(newPath) {
      this.path = newPath;
    },
  },
};
</script>
